export default "__VITE_ASSET__4Ge_We4P__"